<script type="text/javascript">
  // 定义一些公共的属性和方法
  const httpUrl = 'http://test.com'
  const domain = 'https://www.dotaindex.com'
  // const domain = 'http://localhost:8080'
  const oauthApi = 'https://sso.dotaindex.com/sso'
  // 暴露出这些属性
  export default {
    httpUrl,
    domain,
    oauthApi,
    account: null,
    currentJournal: null,
  }
</script>



// WEBPACK FOOTER //
// src/utils/global.vue